import * as moment from 'moment';
import { Loggeable } from '../../../../lib/common/loggeable.cls';
export class FifoItemValidator extends Loggeable {
    /**
     * Contructor detail
     * save reference to provider
     * @param iProvider
     */
    constructor(iProvider) {
        super();
        /**
         * @Override
         *
         * validate a single cached item,
         * gets invoked by the ICache implementations
         * @param iCacheable the item to validate
         */
        this.validate = (iCacheable) => {
            this.log(FifoItemValidator.TAG, 'validate ', iCacheable);
            if ((iCacheable.maxAge + iCacheable.ts) <= this.getNowMs()) {
                this.iProvider.refresh(iCacheable);
            }
        };
        this.iProvider = iProvider;
    }
    /**
     * @Override
     *
     * patch an expired item with new data
     * @param iCacheable the item to validate
     */
    patchItem(oldItem, newItem) {
        var _a, _b, _c, _d;
        const old = oldItem.item;
        let buy_increase_staus = 1;
        if (old.buy_increase_staus !== 'undefined') {
            buy_increase_staus = old.buy_increase_staus;
        }
        if (parseFloat(old.B) > parseFloat(newItem.B)) {
            buy_increase_staus = 0;
        }
        if (parseFloat(old.B) < parseFloat(newItem.B)) {
            buy_increase_staus = 1;
        }
        let sell_increase_staus = 1;
        if (old.sell_increase_staus !== 'undefined') {
            sell_increase_staus = old.sell_increase_staus;
        }
        if (parseFloat(old.A) > parseFloat(newItem.A)) {
            sell_increase_staus = 0;
        }
        if (parseFloat(old.A) < parseFloat(newItem.A)) {
            sell_increase_staus = 1;
        }
        const precision = (_d = (_c = (_b = (_a = newItem.other) === null || _a === void 0 ? void 0 : _a.Tick_Size) === null || _b === void 0 ? void 0 : _b.split(".")[1]) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
        newItem.A = parseFloat(newItem.A).toFixed(precision);
        newItem.B = parseFloat(newItem.B).toFixed(precision);
        newItem.SPREAD = ((parseFloat(newItem.A) - parseFloat(newItem.B)).toFixed(8)).toString();
        newItem.SPREAD = parseFloat(newItem.SPREAD).toString();
        newItem.buy_increase_staus = buy_increase_staus;
        newItem.sell_increase_staus = sell_increase_staus;
        oldItem.item = Object.assign(Object.assign({}, old), newItem);
    }
    // get current timestamp in milliseconds
    getNowMs() {
        return moment().utc().valueOf();
    }
}
// log tag
FifoItemValidator.TAG = 'ItemValidator';



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/cache/fifo-item-validator.cls.ts
// module id = null
// module chunks = 